<template>
  <v-container fluid>
    <v-row justify="end" v-if="items.length > 0">
      <v-col cols="4" class="py-0">
        <sort-by v-model="sortBy" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel v-for="item in items" :key="item.id">
        <v-expansion-panel-header>
          <v-row align="center">
            <v-tooltip bottom z-index="300">
              <template v-slot:activator="{ on }">
                <v-avatar size="24" v-on="on" class="mr-2">
                  <v-img v-if="item.image" :src="item.image"></v-img>
                  <v-icon v-else>mdi-information</v-icon>
                </v-avatar>
              </template>
              <v-container style="max-width: 500px">
                <v-row>
                  <v-col cols="12" v-if="item.image && item.image != ''">
                    <v-img contain :src="item.image" max-height="200"></v-img>
                  </v-col>
                  <v-col cols="12">
                    <div class="max-lines" v-html="item.description"></div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tooltip>
            <strong> {{ item.supplierName }} </strong> &nbsp; ({{
              item.provider == "GTWEB"
                ? "LOCAL"
                : item.provider.replace("GTWEB_", "")
            }})
          </v-row>

          <template v-if="item.priceFrom > 0">
            From:&nbsp; {{ item.priceFrom }}{{ item.currencyCode }}
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <azamara-fare-picker
            v-if="item.provider == 'AZAMARA'"
            :supplier-id="item.id"
            :fare-code="item.services.length ? item.services[0].rateTypeCode : 'BESTPRICE'"
            @repriced="onAzamaraRepriced"
          />
          <v-list dense>
            <v-list-item
              v-for="availableItem in item.services"
              :key="availableItem.id"
              link
              @click="onItemClick(availableItem, item)"
            >
              <v-list-item-avatar>
                <v-tooltip bottom z-index="300">
                  <template v-slot:activator="{ on }">
                    <v-avatar v-on="on">
                      <v-img
                        v-if="availableItem.image"
                        :src="availableItem.image"
                      ></v-img>
                      <v-icon v-else color="green lighten-1">
                        mdi-information</v-icon
                      >
                    </v-avatar>
                  </template>
                  <v-container style="max-width: 500px">
                    <v-row>
                      <v-col cols="12" v-if="availableItem.image">
                        <v-img contain :src="availableItem.image"></v-img>
                      </v-col>
                      <v-col cols="12">
                        <div v-html="availableItem.description"></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tooltip>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <v-tooltip bottom z-index="300">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ availableItem.serviceName }} </span>
                    </template>
                    {{ availableItem.serviceName }}
                  </v-tooltip>
                  <v-chip
                    v-if="isNonRefundable(availableItem)"
                    x-small
                    label
                    color="error"
                    text-color="white"
                    class="ml-1"
                    >Non-refundable</v-chip
                  >
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="availableItem.currencyCode != ''">
                <v-tooltip bottom z-index="300">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ availableItem.price }}
                      {{ availableItem.currencyCode }}
                      ({{ availableItem.rateTypeCode }})
                    </span>
                  </template>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-action v-if="availableItem.currencyCode != ''">
                <v-tooltip bottom z-index="300">
                  <template v-slot:activator="{ on }">
                    <v-btn small text icon color="primary" v-on="on">
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </template>
                  Add
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel></v-expansion-panels
    >
    <v-row align="center" justify="center" v-if="items.length > 0" class="pt-1">
      <v-pagination v-model="page" :length="pages" circle></v-pagination>
    </v-row>
    <v-row align="center" justify="center" v-if="items.length > 0" class="pt-1">
      <span v-for="s of statuses" :key="s.id">
        <strong
          >{{
            s.provider == "GTWEB" ? "LOCAL" : s.provider.replace("GTWEB_", "")
          }}:</strong
        >
        {{ s.status }}, {{ s.total }} records found.&nbsp;
      </span>
      &nbsp;<strong>TOTAL:</strong> &nbsp;{{ total }} record(s).
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ rateSearch }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import EventBus from "../../../../../store/event-bus";
import { removeGQLTypename } from "../../../../../helpers";
import SortBy from "./SortBy.vue";
import AzamaraFarePicker from "./AzamaraFarePicker.vue";
const SEARCH_DETAILS = gql`
  query rateSearchDetails($id: ID!) {
    rateSearch(id: $id) {
      id
      department
      destination {
        id
        name
      }
      adults
      children
      infants
      startDate
      endDate
      serviceTypes
      providers
      status
      total
      agentId
      statuses {
        provider
        status
        total
        message
      }
    }
  }
`;
const RS_RESULT_SUPPLIERS = gql`
  query rateSearchResults(
    $rsId: ID!
    $page: Int
    $pageSize: Int
    $sortBy: SortOrderType
  ) {
    rsResultSuppliers(
      rsId: $rsId
      page: $page
      pageSize: $pageSize
      orderBy: $sortBy
    ) {
      totalCount

      edges {
        node {
          id
          supplierName
          provider
          priceFrom
          currencyCode
          image
          description
          gtSupplier {
            id
            serviceType
          }
          services {
            id
            serviceName
            gtId
            providerId
            price
            currencyCode
            image
            description
            rateTypeCode
            cruiseDetails
            hotelbedsDetails
          }
        }
      }
    }
  }
`;
export default {
  components: { SortBy, AzamaraFarePicker },
  name: "rate-search-results",

  props: {
    searchId: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      reloader: null,
      rsReloader: null,
      panel: null,
      first: 10,
      page: 1,
      pageSize: 10,
      sortBy: {
        fieldName: "supplierName",
        direction: "ASC",
      },
    };
  },

  computed: {
    items() {
      return this.rsResultSuppliers && this.rsResultSuppliers.edges
        ? this.rsResultSuppliers.edges.map(removeGQLTypename)
        : [];
    },
    total() {
      return this.rateSearch ? this.rateSearch.total : 0;
    },
    pages() {
      return Math.ceil(Number(this.total) / this.pageSize);
    },
    statuses() {
      return this.rateSearch ? [...this.rateSearch.statuses] : [];
    },
  },

  methods: {
    onItemClick(service, supplier) {
      //console.log("on item click", service, supplier);
      this.$emit("select", {
        service,
        supplier,
        search: { ...this.rateSearch },
      });
    },
    // #11460 HotelBeds rate class NRF; NOR is refundable
    isNonRefundable(service) {
      return (
        !!service.hotelbedsDetails &&
        service.rateTypeCode == "NRF"
      );
    },
    onAzamaraRepriced() {
      this.$apollo.queries.rsResultSuppliers.refetch();
    },
    reload() {
      if (this.$apollo.queries.rsResultSuppliers != null) {
        const isComplete = this.rateSearch && this.rateSearch.status == "COMPLETE";
        const isError = this.rateSearch && this.rateSearch.status == "ERROR";
        const hasResults = this.items.length > 0;
        const confirmedEmpty =
          this.rsResultSuppliers != null &&
          Number(this.rsResultSuppliers.totalCount) === 0;

        if (isError || (isComplete && (hasResults || confirmedEmpty))) {
          clearInterval(this.reloader);
        } else {
          this.$apollo.queries.rsResultSuppliers.refetch();
        }
      }
    },
    reloadRs() {
      if (this.$apollo.queries.rateSearch != null) {
        if (this.rateSearch && this.rateSearch.status == "ERROR") {
          clearInterval(this.rsReloader);
          const errorMessages = this.rateSearch.statuses
            .filter((s) => s.status == "ERROR" && s.message)
            .map((s) => s.message)
            .join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMessages || "Rate search failed. Please try again.",
            color: "error",
          });
        } else if (this.rateSearch && this.rateSearch.status != "COMPLETE") {
          this.$apollo.queries.rateSearch.refetch();
        } else {
          clearInterval(this.rsReloader);
        }
      }
    },
  },

  apollo: {
    rateSearch: {
      query: SEARCH_DETAILS,
      variables() {
        return {
          id: this.searchId,
        };
      },
      skip() {
        return this.searchId == "";
      },
      fetchPolicy: "network-only",
      result({ data }) {
        console.log("rate search", data);
      },
    },
    rsResultSuppliers: {
      query: RS_RESULT_SUPPLIERS,
      variables() {
        return {
          rsId: this.searchId,
          page: this.page,
          pageSize: this.pageSize,
          sortBy: this.sortBy,
        };
      },
      skip() {
        return this.searchId == "";
      },
      fetchPolicy: "network-only",
    },
  },

  mounted() {
    this.reloader = setInterval(() => {
      this.reload();
    }, 2000);
    this.rsReloader = setInterval(() => {
      this.reloadRs();
    }, 2000);
    EventBus.$on("rs-clear", () => {
      clearInterval(this.reloader);
      clearInterval(this.rsReloader);
    });
  },
  beforeDestroy() {
    clearInterval(this.reloader);
    clearInterval(this.rsReloader);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/rates-search/RateSearchResults.vue